
const router = {
  path: "/index",
  children: [
    {
      //系统公告
      path: "/user/index",
      name: "/user/index",
      icon: "el-icon-iconfontzhizuobiaozhun023101",
      label: "我的主页",
      translate: "user_Index_WDZY",
      children: [],
    },
    //用户
    {
      path: "/index/wantOrder",
      name: "/index/wantOrder",
      icon: "el-icon-zhanghu",
      label: "客户导航",
      translate: "user_Index_KHDAH",
      children: [
        {
          path: "/index/wantOrder",
          name: "/index/wantOrder",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "验货下单",
          target: "_blank",
          translate: "user_Index_YHXD",
        },
        {
          path: "/user/Mysuppliers",
          name: "/user/Mysuppliers",
          icon: "el-icon-zhanghu",
          label: "供应商管理",
          translate: "user_Index_GYSGL",
        },
        {
          path: "/user/orderManage",
          name: "/user/orderManage",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "订单管理",
          translate: "user_Index_DDGL",
        },
        {
          path: "/user/accountManage",
          name: "/user/accountManage",
          icon: "el-icon-zhanghu",
          label: "用户资料",
          translate: "user_Index_HHZL",
        },
      ],
    },
    //验货员
    {
      path: "/index/wantOrder",
      name: "/index/wantOrder",
      icon: "el-icon-xiadan",
      label: "验货员导航",
      translate: "user_Index_YHYDH",
      children: [
        {
          path: "/insp/sindex",
          name: "/insp/sindex",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "验货申请",
          is_role: 1,
          translate: "user_Index_YHSQ",
        },
        {
          path: "/insp/evaluate",
          name: "/insp/evaluate",
          icon: "el-icon-zhanghu",
          label: "评价管理",
          is_role: 1,
          translate: "user_Index_PJGL",
        },
        {
          path: "/insp/orderManage",
          name: "/insp/orderManage",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "验货管理",
          is_role: 1,
          translate: "user_Index_YHGL",
        },
        {
          path: "/insp/accountManage",
          name: "/insp/accountManage",
          icon: "el-icon-zhanghu",
          label: "验货员档案",
          is_role: 1,
          translate: "user_Index_YHYDA",
        },
      ],
    },

    {
      //第三方采购
      path: "/purchase",
      name: "/purchase",
      icon: "el-icon-goods",
      label: "第三方采购",
      translate: "user_Index_DSFCG",
      children: [
        {
          path: "/purchase/add",
          name: "/purchase/add",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "发布采购",
          target: "_blank",
          translate: "user_Index_FBCG",
        },
        {
          path: "/purchase",
          name: "/purchase",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "采购广场",
          target: "_blank",
          translate: "user_Index_CGGC",
        },
        {
          path: "/purchase/my",
          name: "/purchase/my",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "我的采购",
          target: "_blank",
          translate: "user_Index_WDCG",
        },
        {
          path: "/purchase/myreply",
          name: "/purchase/myreply",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "我的回复",
          target: "_blank",
          translate: "user_Index_WDHF",
        },
        {
          path: "/purchase/myappeal",
          name: "/purchase/myappeal",
          icon: "el-icon-iconfontzhizuobiaozhun023101",
          label: "我的申诉",
          target: "_blank",
          translate: "user_Index_WDSSF",
        },
      ],
    },
    //工厂导航
    {
      path: "/insp/orderHelp",
      name: "/insp/orderHelp",
      icon: "el-icon-comment-w",
      label: "工厂导航",
      translate: "user_Index_GCDH",
      children: [
        {
          path: "/insp/orderHelp",
          name: "/insp/orderHelp",
          icon: "el-icon-zhanghu",
          label: "验货协助",
          translate: "user_Index_YHXZ",
        },
      ],
    },
    //通用导航
    {
      path: "/index/wantOrder",
      name: "/index/wantOrder",
      icon: "el-icon-menu",
      label: "通用导航",
      translate: "user_Index_TYDH",
      children: [
        {
          path: "/user/fundManage",
          name: "/user/fundManage",
          icon: "el-icon-zhanghu",
          label: "资金管理",
          translate: "user_Index_ZJGL",
        },
        // {
        //   //推广有礼
        //   path: "promotion",
        //   name: "promotion",
        //   icon: "el-icon-yemiantuiguang",
        //   label: "推广管理",
        //   translate: "user_Index_TGGL",
        //   children: [],
        // },
      ],
    },

    /*{
            path: '/index/wantOrder',
            name: '/index/wantOrder',
            icon: 'el-icon-xiadan',
            label: '我要下单',
            translate:'user_Index_WYXD',
			children:[]
          },
          {
            path: 'orderManage',
            name: 'orderManage',
            icon: 'el-icon-dingdan1',
            label: '订单管理',
            translate:'user_Index_DDGL',
			children:[]
          },
          {
            path: 'fundManage',
            name: 'fundManage',
            icon: 'el-icon-zijinguanli',
            label: '资金管理',
            translate:'user_Index_ZJGL',
			children:[]
          },
          {
            path: 'evaluate',
            name: 'evaluate',
            icon: 'el-icon-comment-w',
            label: '评价管理',
            translate:'user_Index_PJGL',
			children:[]
          },
          {
            path: 'accountManage',
            name: 'accountManage',
            icon: 'el-icon-zhanghu',
            label: '账户设置',
            translate:'user_Index_ZHSZ',
			children:[]
          },
          {//推广有礼
            path: 'promotion',
            name: 'promotion',
            icon: 'el-icon-yemiantuiguang',
            label: '推广管理',
            translate:'user_Index_TGGL',
			children:[]
          },
          {
            path: 'Mysuppliers',
            name: 'Mysuppliers',
            icon: 'el-icon-s-grid',
            label: '我的供应商',
            translate:'user_Index_MYGYS',
			children:[]
          },*/
  ],
};
export default router